.ak{aspect-ratio:1/1;}